/**
 * Error reporting utility.
 *
 * Currently a no-op placeholder. Replace the body of `reportError` with a
 * real error-tracking integration (e.g. Sentry, Datadog) when ready.
 */

export interface ErrorInfo {
  componentStack?: string | null;
  [key: string]: unknown;
}

/**
 * Report an error to the monitoring backend.
 * Safe to call from both React class-component lifecycle methods and plain JS.
 */
export function reportError(error: unknown, errorInfo?: ErrorInfo): void {
  // TODO: integrate with a real error-tracking service (e.g. Sentry)
  // e.g. Sentry.captureException(error, { extra: errorInfo });
}
